import { useRef, useState } from "react";
import { Camera, Image as ImageIcon, Loader2, ScanSearch, X } from "lucide-react";
import { toast } from "sonner";
import { shrink } from "@/components/PhotoPicker";
import { api, errMsg } from "@/lib/api";

export const PhotoSearch = ({ scope, Card, theme = "faunny" }) => {
  const gal = useRef(null);
  const cam = useRef(null);
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const [res, setRes] = useState(null);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true); setRes(null);
    try {
      const photo = await shrink(file);
      setPreview(photo);
      setRes((await api.post("/busqueda-foto", { photo, scope })).data);
    } catch (err) { toast.error(errMsg(err)); setPreview(null); }
    setBusy(false);
  };
  const warm = theme === "adopt";
  const btn = `inline-flex items-center gap-2 font-bold text-sm px-4 py-2.5 rounded-full border-2 transition-colors ${warm ? "border-[#3D405B] text-[#3D405B] hover:bg-[#3D405B] hover:text-white" : "border-[#0B1D3A] text-[#0B1D3A] hover:bg-[#0B1D3A] hover:text-white"}`;
  return (
    <div className={`rounded-3xl p-4 sm:p-5 mb-6 ${warm ? "bg-white" : "bg-[#EFF6FF]"}`} data-testid="photo-search">
      <input ref={gal} type="file" accept="image/*" onChange={pick} className="hidden" data-testid="photo-search-input" />
      <input ref={cam} type="file" accept="image/*" capture="environment" onChange={pick} className="hidden" data-testid="photo-search-camera-input" />
      <div className="flex flex-wrap items-center gap-3">
        <p className={`font-bold flex items-center gap-2 mr-2 ${warm ? "text-[#3D405B]" : "text-[#0B1D3A]"}`}><ScanSearch size={20} className={warm ? "text-[#E07A5F]" : "text-[#DC2626]"} /> Buscar con una foto</p>
        <button type="button" disabled={busy} onClick={() => gal.current?.click()} className={btn} data-testid="photo-search-gallery"><ImageIcon size={16} /> Subir imagen</button>
        <button type="button" disabled={busy} onClick={() => cam.current?.click()} className={btn} data-testid="photo-search-camera"><Camera size={16} /> Hacer foto</button>
        {(res || preview) && !busy && <button type="button" onClick={() => { setRes(null); setPreview(null); }} className="text-sm font-bold text-slate-500 inline-flex items-center gap-1" data-testid="photo-search-close"><X size={14} /> Cerrar</button>}
      </div>
      {(busy || res) && (
        <div className="mt-4 flex gap-4 items-start">
          {preview && <img src={preview} alt="Tu foto" className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-xl shrink-0" data-testid="photo-search-preview" />}
          <div className="text-sm text-slate-700">
            {busy ? <p className="inline-flex items-center gap-2"><Loader2 size={16} className="animate-spin" /> Analizando la foto…</p> : (<>
              <p data-testid="photo-search-description">{res.description}</p>
              <p className="mt-1 font-bold" data-testid="photo-search-count">{res.results.length ? `${res.exact > 0 ? `${res.exact} muy parecidos` : "Ninguno idéntico"} · te mostramos los más parecidos primero` : "Todavía no hay anuncios parecidos."}</p>
            </>)}
          </div>
        </div>
      )}
      {res?.results?.length > 0 && <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-5" data-testid="photo-search-results">{res.results.map((x) => <Card key={x.id} x={x} />)}</div>}
    </div>
  );
};
